import { Component, OnDestroy, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { CmsService } from '~/cms/services/cms/cms.service';
import { CustomHeadTagService } from '~/core/services/custom-head-tag/custom-head-tag.service';
import { CmsPage } from '~/cms/interfaces/homepage.cms.interface';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit, OnDestroy {
  private subscription$: Subscription;
  public page: CmsPage;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly cms: CmsService,
    private readonly meta: Meta,
    private readonly customHeadTagService: CustomHeadTagService,
    private readonly router: Router
  ) {}

  public ngOnDestroy(): void {
    this.subscription$?.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscription$ = this.route.paramMap
      .pipe(
        switchMap((params: ParamMap) =>
          this.cms.getPageBySlug(params.get('slug'))
        ),
        tap((page: CmsPage | null) => {
          if (!page) {
            this.router.navigate(['/attendee.not-found']);
          }
        }),
        map((page: CmsPage | null) => {
          if (!page) {
            throw new Error('Page not found');
          }
          return page;
        })
      )
      .subscribe({
        next: (page: CmsPage) => {
          this.page = page;

          if (page.seo) {
            const { html, rdfa, link: linkCollection } = page.seo;
            const tags = [...html, ...rdfa];

            tags.forEach((tag) => {
              // our cms adds an id over every object
              // if we dont delete it the <meta> will have an id
              delete tag.id;

              // we use update instead of add to avoid duplication of <meta>
              this.meta.updateTag(tag);
            });

            if (linkCollection.length) {
              linkCollection.forEach((seoLink) => {
                this.customHeadTagService.addTag('link', {
                  ...(seoLink.rel && { rel: seoLink.rel }),
                  ...(seoLink.href && { href: seoLink.href }),
                  ...(seoLink.hreflang && { hreflang: seoLink.hreflang }),
                });
              });
            }
          }
        },
        error: () => {
          this.page = null;
        },
      });
  }
}
